const SEM_NOME = "Sem nome";

/**
 * Identificação padrão do resultado: posição na lista seguida do nome.
 * @param {object|null|undefined} resultado
 * @param {number} index posição do resultado na lista (base zero)
 * @returns {string}
 */
export function rotuloResultado(resultado, index) {
  const nome = String(resultado?.nome ?? "").trim();
  return `${Number(index) + 1}. ${nome || SEM_NOME}`;
}

/**
 * Texto do tooltip: rótulo do resultado e, quando houver, o resultado esperado.
 * @param {object|null|undefined} resultado
 * @param {number} index posição do resultado na lista (base zero)
 * @returns {string}
 */
export function tituloResultado(resultado, index) {
  const rotulo = rotuloResultado(resultado, index);
  const descricao = String(resultado?.descricao ?? "").trim();
  return descricao ? `${rotulo}\n${descricao}` : rotulo;
}
